var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Giclee Sizes")]),_c('v-card-text',[(_vm.sizes.length)?_c('v-data-table',{attrs:{"items":_vm.sizes,"headers":_vm.headers,"disable-pagination":true,"hide-default-footer":true,"dense":""}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }